import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

interface Props {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin }: Props) {
  const { employee, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center text-gray-400">
        Loading...
      </div>
    );
  }

  if (!employee) {
    return <Navigate to="/" replace state={{ from: location.pathname + location.search }} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/home" replace />;
  }

  // Someone who arrived from an email link chooses their PIN on top of the
  // page the email was about (PinChangeOverlay is global), so they land there.
  if (
    employee.must_change_pin &&
    !employee.pin_setup &&
    !employee.is_kiosk &&
    !location.pathname.startsWith("/me")
  ) {
    return <Navigate to="/me" replace />;
  }

  return <>{children}</>;
}
